import I18n from "components/materials/I18n";
import PageTemplate from "components/PageTemplate";
import classes from "./classes.module.scss";
import { container } from "tsyringe";
import ModuleConfig from "configs/ModuleConfig";
import NavTabOutlet from "components/elements/NavTabOutlet";
import Button from "components/elements/Button";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { ESubStep } from "common/enums/Subscription/ESubStep";
import ProductSubscribedService from "services/ProductSubscribedService";

const modules = container.resolve(ModuleConfig).get().modules;
const MOSubscriptionPages = modules.pages.MOSubscriptions.props.pages;
const MOManualSubscription = modules.pages.MOManualSubscription;
const productSubscribedService = container.resolve(ProductSubscribedService);

const STEPS_BY_TAB: Record<string, ESubStep[]> = {
	draft: [ESubStep.draft],
	to_process: [ESubStep.processing],
	waiting_signature: [ESubStep.waiting_signature],
	waiting_contrepartie: [ESubStep.waiting_contrepartie],
	waiting_transfer_sg: [ESubStep.waiting_transfer_sg],
	waiting_validation: [ESubStep.waiting_validation],
	validated: [ESubStep.validated],
};

function MOSubscriptions() {
	const navigate = useNavigate();
	const [counts, setCounts] = useState<Record<string, number>>({});

	const goToManualSubscription = () => {
		navigate(MOManualSubscription.props.path);
	};

	useEffect(() => {
		const fetchCounts = async () => {
			const entries = await Promise.all(
				Object.entries(STEPS_BY_TAB).map(async ([tab, steps]) => {
					const res = await productSubscribedService.countByStepsAdmin(steps);
					return [tab, res.count] as const;
				}),
			);
			setCounts(Object.fromEntries(entries));
		};
		fetchCounts();
	}, []);

	return (
		<PageTemplate
			tabTitle={I18n.asset.pages.mo_subscriptions.page_title}
			headerTitle={I18n.asset.pages.mo_subscriptions.title}
			rightElement={<Button onClick={goToManualSubscription}>{I18n.asset.pages.mo_subscriptions.button}</Button>}>
			<div className={classes["root"]}>
				<NavTabOutlet
					isCountEnabled
					items={[
						{ label: I18n.asset.pages.mo_subscriptions.sub_pages.draft.page_title, path: MOSubscriptionPages.Draft.props.path, count: counts["draft"] ?? 0 },
						{ label: I18n.asset.pages.mo_subscriptions.sub_pages.to_process.page_title, path: MOSubscriptionPages.ToProcess.props.path, count: counts["to_process"] ?? 0 },
						{
							label: I18n.asset.pages.mo_subscriptions.sub_pages.waiting_signature.page_title,
							path: MOSubscriptionPages.WaitingSignature.props.path,
							isSpecial: true,
							count: counts["waiting_signature"] ?? 0,
						},
						{
							label: I18n.asset.pages.mo_subscriptions.sub_pages.waiting_contrepartie.page_title,
							path: MOSubscriptionPages.WaitingContrepartie.props.path,
							isSpecial: true,
							count: counts["waiting_contrepartie"] ?? 0,
						},
						{
							label: I18n.asset.pages.mo_subscriptions.sub_pages.waiting_transfer_sg.page_title,
							path: MOSubscriptionPages.WaitingTransferSg.props.path,
							isSpecial: true,
							count: counts["waiting_transfer_sg"] ?? 0,
						},
						{
							label: I18n.asset.pages.mo_subscriptions.sub_pages.waiting_validation.page_title,
							path: MOSubscriptionPages.WaitingValidation.props.path,
							count: counts["waiting_validation"] ?? 0,
						},
						{ label: I18n.asset.pages.mo_subscriptions.sub_pages.validated.page_title, path: MOSubscriptionPages.Validated.props.path, count: counts["validated"] ?? 0 },
					]}
				/>
			</div>
		</PageTemplate>
	);
}

export default MOSubscriptions;
